import React, { useContext, useRef } from 'react';

import { getFirstValidMainItemSelector } from '../../../services/validators/selectors/selectors';
import { linearProgressMessages } from '../../../translates/linearProgressMessages';
import { useIsMobile } from '../../hooks/useIsMobile';
import { Guid } from '../../store/model/guid';
import { getItemByIdSelector, getParentSubmenuByChildIdSelector } from '../../store/reducers/items/itemsSelectors';
import { useSelectItem } from '../../store/reducers/items/useSelectItem';
import { useStudentSelector } from '../../store/selectors/useStudentSelector';
import { LinearProgressContext } from './LinearProgressContext';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { CSSTransition } from 'react-transition-group';

import './ProgressDialog.scss';
import {createSelector} from "reselect";

const isFirstItemSelector = (itemId: Guid | undefined) =>
    createSelector(
        [getFirstValidMainItemSelector],
        (firstItem) => firstItem?.id === itemId
    );

export const ProgressDialog = () => {
  const progressRef = useRef(null);
  const { displayGoTo } = useContext(LinearProgressContext);
  const { goToItem } = useSelectItem();
  const getItemById = useStudentSelector((state) => getItemByIdSelector(state));

  const isFirstValue = useStudentSelector(isFirstItemSelector(displayGoTo?.itemId))
  const tryGetParentSubmenu = useStudentSelector((state) => getParentSubmenuByChildIdSelector(state));
  const isMobile = useIsMobile();

  const isFirst = displayGoTo ? isFirstValue :null;
  const nextItemId = displayGoTo ? displayGoTo.itemId  :null;

  if (!nextItemId) {
    return null;
  }
  const parentSubmenuResult = tryGetParentSubmenu(nextItemId);
  const nextItem = getItemById(nextItemId);

  return (
    <div className="progress-dialog__positioner">
      <CSSTransition
        nodeRef={progressRef}
        timeout={500}
        classNames={isMobile ? 'slide-from-bottom' : 'slide-left'}
        in
        appear
      >
        <div ref={progressRef} className="progress-dialog">
          <div className="progress-dialog__text-wrapper">
            <div className="progress-dialog__next-label">
              <FormattedMessage {...(isFirst ? linearProgressMessages.startHere : linearProgressMessages.nextLesson)} />
            </div>
            {parentSubmenuResult.success && (
              <div className="progress-dialog__submenu">{parentSubmenuResult.value.title}</div>
            )}
            <div className="progress-dialog__item-name">{nextItem.title}</div>
          </div>
          <div className="progress-dialog__next-button" onClick={() => goToItem(nextItem.id)}>
            <FontAwesomeIcon icon={solid('chevron-right')} />
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};
